import './css/reset.css';
import './css/style.css';
import 'animate.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import Routes from './components/Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import AnimacionInicial from './components/AnimacionInicial';
import Menu from './components/Menu';
import Busqueda from './components/Busqueda';
import { useState } from 'react';

function App() {

  const [showMenu, setShowMenu] = useState(false);
  const [showBusqueda, setShowBusqueda] = useState(false);

  return (
    <Router>
      {  <AnimacionInicial/>  }
      <main>
      {  <Header showMenu={showMenu} setShowMenu={setShowMenu} showBusqueda={showBusqueda} setShowBusqueda={setShowBusqueda}/>}
      {  <Menu showMenu={showMenu} setShowMenu={setShowMenu}/>}
      {  <Busqueda showBusqueda={showBusqueda} setShowBusqueda={setShowBusqueda}/>}
        <Routes showBusqueda={showBusqueda} setShowBusqueda={setShowBusqueda}/>
      </main>
    </Router>
  );
}

export default App;
